import {
    useEffect,
    useState,
} from 'react';

// FNP-918: module-scoped keyword store (checklist §3, §4; FNP-815).
//
// The search input (TableSearchForm, rendered by RecordsTable) and the
// filtering (useSubscriptionItems) are different components. A plain `useState`
// gives each its own copy, so what is typed never reaches the filter — that is
// the exact regression shape FNP-815 was filed for. The previous
// implementation held the keyword in `useState` INSIDE useSubscriptionItems, so
// every consumer of that hook had a private keyword.
//
// ⚠️ This is a module-scoped store for KEYWORD, which is legitimate: it is
// shared UI state across siblings. It is NOT the retired selection singleton —
// selection lives in the Redux subscription-items.selection slice (FNP-951).
let globalKeyword = '';
const keywordListeners: Set<(keyword: string) => void> = new Set();

const notifyKeywordChange = (keyword: string) => {
    globalKeyword = keyword;
    keywordListeners.forEach(listener => listener(keyword));
};

/** Test seam: resets the store so keyword does not leak between test cases. */
export const resetSubscriptionItemsSearch = () => {
    globalKeyword = '';
    keywordListeners.forEach(listener => listener(''));
};

export const useSubscriptionItemsSearch = () => {
    const [keyword, setKeyword] = useState<string>(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => setKeyword(newKeyword);
        keywordListeners.add(listener);
        return () => {
            keywordListeners.delete(listener);
        };
    }, []);

    return {
        keyword,
        handleFilterByKeyword: notifyKeywordChange,
    };
};
